import builder from '../builder';
import MessagesBubbleTyping1 from '../../streamline-icons/bold/messages-bubble-typing-1.svg';

export default builder('IconMessagesBubbleTyping1Bold', MessagesBubbleTyping1);
